<template>
  <div
    class="icon"
    :class="glyph + '-icon'"
    :style="style"
    @click="$emit('click', $event)"
  >
    <svg style="width: 100%; height: 100%;">
      <use v-bind="{ 'xlink:href': '#' + glyph }"></use>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    glyph: {
      required: true
    },
    size: {
      type: String
    }
  },

  computed: {
    style() {
      const style = {}
      if (this.size) {
        let size = this.size
        if (String(size).match(/^\d+$/)) {
          size += 'px'
        }
        style.width = size
        style.height = size
      }

      return style
    }
  },

  watch: {
    glyph: {
      immediate: true,
      handler() {
        // eslint-disable-next-line no-undef
        require('@/img/svg/' + this.glyph + '.svg')
      }
    }
  }
}
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
}

.icon svg {
  pointer-events: none;
  position: relative;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/common/components/Icon.vue